import { render, staticRenderFns } from "./JoinAer.vue?vue&type=template&id=60fbd8c0&"
import script from "./JoinAer.vue?vue&type=script&lang=js&"
export * from "./JoinAer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports